import { render, staticRenderFns } from "./inactiveClient.vue?vue&type=template&id=052acd3f&scoped=true"
import script from "./inactiveClient.vue?vue&type=script&lang=js"
export * from "./inactiveClient.vue?vue&type=script&lang=js"
import style0 from "./inactiveClient.vue?vue&type=style&index=0&id=052acd3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052acd3f",
  null
  
)

export default component.exports